import * as React from 'react';
import {Checkbox} from '@sail/ui';

export const Primary = () => {
  return <Checkbox label="This is a Checkbox." />;
};
